import { useMemo } from "react";
import { ChevronLeftIcon, UserIcon } from "@heroicons/react/24/solid";
import PhoneFrame from "./PhoneFrame";

const IphoneSmsPreviewHeader = ({
  merchantName,
  children,
}) => {
  const timestamp = useMemo(() => {
    const now = new Date();
    const day = now.toLocaleDateString("en-GB", { weekday: "short" });
    const date = now.getDate();
    const month = now.toLocaleDateString("en-GB", { month: "short" });
    const time = now.toLocaleTimeString("en-GB", { hour: "numeric", minute: "2-digit", hour12: true });
    return `${day}, ${date} ${month} at ${time}`;
  }, []);

  return (
    <PhoneFrame>
      <div className="flex-1 min-h-0 overflow-y-auto">
        {/* Contact header */}
        <div className="cursor-default flex flex-col items-center pt-1">
          <div className="flex items-center justify-between w-full px-2 py-1 text-blue-500">
            <ChevronLeftIcon className="size-4" />
            <span className="size-4" />
          </div>

          <div className="w-10 h-10 rounded-full bg-zinc-400 flex items-center justify-center">
            <UserIcon className="size-5 text-white" />
          </div>

          <p className="text-xs font-bold text-zinc-800 mt-1.5 pb-6">
            {merchantName || "Unknown"}
          </p>

          <p className="text-[10px] text-zinc-400 leading-tight mt-0.5">
            Text message &middot; SMS
          </p>
          <p className="text-[10px] text-zinc-400 leading-tight">
            {timestamp}
          </p>
        </div>

        {/* Message area */}
        <div className="p-3">{children}</div>
      </div>

      {/* Input bar */}
      <div className="shrink-0 px-3 pb-3 pt-1">
        <div className="bg-zinc-100 rounded-full px-4 py-2 text-xs text-zinc-400 shadow-sm">
          Text message &middot; SMS
        </div>
      </div>
    </PhoneFrame>
  );
};

export default IphoneSmsPreviewHeader;
